import {
  Flex,
  Text,
  CallVideoIcon,
  Image,
  VolumeUpIcon,
  MicIcon,
} from "@fluentui/react-northstar";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Devices } from "../../../../types/Device.types";
import { getLocalizedDeviceName } from "../../utils/getLocalizedDeviceName";

import { MobileDeviceStatusCardProps } from "./MobileDeviceStatusCard.types";
import { useMobileDeviceStatusCardStyles } from "./MobileDeviceStatusCard.styles";
import { ConnectedMobileDeviceStatusDialogButton } from "./mobile-device-status-dialog-button/ConnectedMobileDeviceStatusDialogButton";

export const MobileDeviceStatusCard: React.FC<MobileDeviceStatusCardProps> = ({
  testResult,
  deviceName,
}) => {
  const mobileDeviceCardTitleStyles = useMobileDeviceStatusCardStyles();
  const { t } = useTranslation();

  const getIcon = useMemo(() => {
    switch (deviceName) {
      case Devices.Network:
        return (
          <Image
            styles={mobileDeviceCardTitleStyles.deviceIcon}
            src="/assets/images/connectionIconWhite.svg"
          />
        );
      case Devices.Camera:
        return <CallVideoIcon outline size="medium" />;
      case Devices.Speaker:
        return <VolumeUpIcon outline size="medium" />;
      case Devices.Mic:
        return <MicIcon outline size="medium" />;
    }
  }, [deviceName, mobileDeviceCardTitleStyles.deviceIcon]);

  const deviceNameString = getLocalizedDeviceName(deviceName, t, false);

  return (
    <Flex
      styles={mobileDeviceCardTitleStyles.container}
      space="between"
      gap="gap.small"
      padding="padding.medium"
    >
      <Flex space={"between"} gap="gap.small">
        <Flex gap="gap.medium" hAlign="center" vAlign="center">
          {getIcon}

          <Text
            aria-hidden="true"
            size="large"
            weight="regular"
            align="center"
            content={deviceNameString}
          />
        </Flex>
      </Flex>
      <ConnectedMobileDeviceStatusDialogButton
        status={testResult.status}
        deviceName={deviceName}
      />
    </Flex>
  );
};
